export class DatabricksResourceNotAllowedError extends Error {
  readonly code = "DATABRICKS_RESOURCE_NOT_ALLOWED";
  readonly resourceKind: string;

  constructor(resourceKind: string) {
    super(`Databricks ${resourceKind} is not allowed by the configured policy.`);
    this.name = "DatabricksResourceNotAllowedError";
    this.resourceKind = resourceKind;
  }
}

export function resolveExactResourcePolicy(
  policy: unknown,
  allowedKey: string,
  allowAnyKey: string,
  resourceKind: string,
): readonly string[] | undefined {
  if (!policy || typeof policy !== "object" || Array.isArray(policy))
    throw new TypeError(`Databricks ${resourceKind} policy must be an object.`);
  const value = policy as Record<string, unknown>;
  const allowed = value[allowedKey];
  const allowAny = value[allowAnyKey];
  if (allowAny === true && allowed === undefined) return undefined;
  if (
    Array.isArray(allowed) &&
    allowed.length > 0 &&
    allowed.every((entry) => typeof entry === "string" && entry.trim().length > 0) &&
    allowAny === undefined
  )
    return [...new Set(allowed.map((entry) => entry.trim()))];
  throw new TypeError(
    `Databricks ${resourceKind} policy must set either non-empty ${allowedKey} or ${allowAnyKey}: true.`,
  );
}

export function assertExactResourceAllowed(
  resourceKind: string,
  value: string,
  allowed: readonly string[] | undefined,
): void {
  if (allowed && !allowed.includes(value.trim()))
    throw new DatabricksResourceNotAllowedError(resourceKind);
}

export function pinnedStringResourceSchema(
  allowed: readonly string[] | undefined,
): Record<string, unknown> {
  if (!allowed) return { type: "string" };
  if (allowed.length === 1) return { type: "string", const: allowed[0] };
  return { type: "string", enum: [...allowed] };
}
